
import { Breadcrumb, Space, Menu, Row, Col } from 'antd';
import { CheckCircleOutlined, HomeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import ReportModulePurchases from './ReportViews/ReportModulePurchases';
import ReportTransactions from './ReportViews/ReportTransactions';
import ReportDefault from './ReportViews/ReportDefault';



const AdminReports = ({ match }) => {

    let RenderedComponent;
    switch (match.params.type) {
        case 'module-purchases':
            RenderedComponent = <ReportModulePurchases />;
            break;
        case 'transactions':
            RenderedComponent = <ReportTransactions />;
            break;
        default:
            RenderedComponent = <ReportDefault />;
    }

    return <div className="centered-container">
        <Space className="breadcrumbs">
            <Breadcrumb>
                <Breadcrumb.Item>
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item><Link to="/admin">Admin Home</Link></Breadcrumb.Item>
                {(() => {
                    switch (match.params.type) {
                        case 'module-purchases':
                            return <><Breadcrumb.Item><Link to="/admin/reports/">Reports</Link></Breadcrumb.Item><Breadcrumb.Item>Purchased Modules</Breadcrumb.Item></>;
                        case 'transactions':
                            return <><Breadcrumb.Item><Link to="/admin/reports/">Reports</Link></Breadcrumb.Item><Breadcrumb.Item>Transactions</Breadcrumb.Item></>;
                        default:
                            return <Breadcrumb.Item>Reports</Breadcrumb.Item>;
                    }
                })()}
            </Breadcrumb>
        </Space>
        <br />
        <br />

        <Row>
            <Col span={4}>
                <div style={{ background: 'white', minHeight: 'calc(100vh - 48px - 98px - 70px)', height: "100%" }}>
                    <Menu selectedKeys={[match.params.type]} mode="inline" >
                        <Menu.Item key="module-purchases" icon={<CheckCircleOutlined />}>
                            <Link to="/admin/reports/module-purchases/">Purchased Modules</Link>
                        </Menu.Item>
                        <Menu.Item key="others2" icon={<CheckCircleOutlined />}>
                            <Link to="/admin/reports/transactions/">Transactions</Link>
                        </Menu.Item>
                        <Menu.Item key="others" icon={<CheckCircleOutlined />} disabled="true">
                            <Link to="/others/">Other Reports (cont...)</Link>
                        </Menu.Item>
                    </Menu>
                </div>
            </Col>
            <Col span={20}>
                <div style={{ minHeight: 'calc(100vh - 48px - 98px - 70px)', background: 'white', padding: '20px', borderLeft: '1px solid #f0f0f0' }}>
                    {RenderedComponent}
                </div>
            </Col>
        </Row>


    </div>
}

export default AdminReports
